module.exports = __webpack_public_path__ + "img/icon-no-coding.b6736e7c.svg";